import { Observable } from 'rxjs';
import { pairwise, startWith } from 'rxjs/operators';

export const withPrevious =
  <T extends {}>() =>
  (source: Observable<T>) =>
    source.pipe(startWith(null), pairwise()) as Observable<[T | null, T]>;
